import { useEffect, useState } from "react";
import { api } from "../lib/api";

/** Material categories, key → label, ordered as in Settings (archived
 *  included so an old material's category still names itself). */
export function useMaterialCategories() {
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    let alive = true;
    api.get("/material-categories", { params: { include_archived: true } })
      .then((r) => { if (alive) setCategories(Array.isArray(r.data) ? r.data : []); })
      .catch(() => { if (alive) setCategories([]); });
    return () => { alive = false; };
  }, []);
  return categories;
}
